import { Typography, Separator, Loading, Button } from '@ui/components';
import { Cancel, Plus, User } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';

import { AddEmployeesHeader, EmployeePreview, EmployeeForm } from '../../containers/';
import { useOnboardingEmployees } from './use-onboarding-employees';

export const OnboardingEmployees = () => {
  const { t } = useTranslation();
  const {
    isAvailableVehiclesLoading,
    isEmployeesFormVisible,
    isSaveMutationPending,
    availableVehicles,
    savedEmployees,
    form,
    handleCopyUserRegistrationData,
    checkIfPhoneNumberIsUnique,
    handleSaveAndContinue,
    handleRemoveEmployee,
    closeEmployeesForm,
    handleEditEmployee,
    addNextEmployee,
    handleSubmit,
  } = useOnboardingEmployees();

  if (isAvailableVehiclesLoading) {
    return <Loading />;
  }

  return (
    <>
      <AddEmployeesHeader className="mb-7" />

      {!savedEmployees.length && (
        <div className="flex mb-6">
          <Button
            onClick={handleCopyUserRegistrationData}
            className="ml-auto px-0"
            variant="link"
            size="large"
          >
            {t('ONBOARDING.ADD_EMPLOYEES.COPY_FROM_REGISTRATION')}
          </Button>
        </div>
      )}

      {savedEmployees.map((employee, idx) => (
        <Fragment key={employee.phoneNumber + idx}>
          <EmployeePreview
            handleEditEmployee={(employee) => handleEditEmployee(employee, idx)}
            checkIfPhoneNumberIsUnique={checkIfPhoneNumberIsUnique}
            handleRemoveEmployee={() => handleRemoveEmployee(idx)}
            availableVehicles={availableVehicles ?? []}
            key={employee.phoneNumber + idx}
            employeeIndex={idx}
            employee={employee}
          />
          {idx !== savedEmployees.length - 1 && <Separator className="my-8" />}
        </Fragment>
      ))}

      {isEmployeesFormVisible && savedEmployees.length > 0 && (
        <>
          <Separator className="my-8" />
          <div className="flex items-center gap-2 mb-6">
            <User className="size-4" />
            <Typography variant="h100">
              {t('ONBOARDING.ADD_EMPLOYEES.EMPLOYEE')} {savedEmployees.length + 1}
            </Typography>

            <Button onClick={closeEmployeesForm} className="ml-auto" variant="ghost">
              <Cancel className="size-4" />
            </Button>
          </div>
        </>
      )}

      {isEmployeesFormVisible && (
        <EmployeeForm availableVehicles={availableVehicles} onSubmit={handleSubmit} form={form} />
      )}

      <Separator className="my-8" />
      <Button onClick={addNextEmployee} variant="secondary" size="large" wide>
        {t('ONBOARDING.ADD_EMPLOYEES.ADD_NEXT_EMPLOYEE')}
        <Plus className="size-4" />
      </Button>

      <Separator className="my-8" />
      <Button
        isLoading={isSaveMutationPending}
        disabled={isSaveMutationPending}
        onClick={handleSaveAndContinue}
        variant="primary"
        size="large"
        wide
      >
        {t('ONBOARDING.ADD_EMPLOYEES.SAVE_AND_CONTINUE')}
      </Button>
    </>
  );
};
